/**
 * Reaction Operations
 * Functions for managing message reactions in chat
 */

import {
  doc,
  updateDoc,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { log } from '@/lib/logger';

const MESSAGES_COLLECTION = 'chat_messages';

/**
 * Add a reaction to a message
 * @param messageId - The Firestore document ID of the message
 * @param emoji - The emoji to add
 * @param clientId - The user's client ID (employee ID)
 */
export async function addReaction(
  messageId: string,
  emoji: string,
  clientId: string
): Promise<void> {
  try {
    const messageRef = doc(db, MESSAGES_COLLECTION, messageId);
    await updateDoc(messageRef, {
      [`reactions.${emoji}`]: arrayUnion(clientId),
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    log.error('Error adding reaction:', error);
    throw error;
  }
}

/**
 * Remove a reaction from a message
 * @param messageId - The Firestore document ID of the message
 * @param emoji - The emoji to remove
 * @param clientId - The user's client ID (employee ID)
 */
export async function removeReaction(
  messageId: string,
  emoji: string,
  clientId: string
): Promise<void> {
  try {
    const messageRef = doc(db, MESSAGES_COLLECTION, messageId);
    await updateDoc(messageRef, {
      [`reactions.${emoji}`]: arrayRemove(clientId),
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    log.error('Error removing reaction:', error);
    throw error;
  }
}
